import { render, staticRenderFns } from "./McTabTable.vue?vue&type=template&id=e0863772&"
import script from "./McTabTable.vue?vue&type=script&lang=js&"
export * from "./McTabTable.vue?vue&type=script&lang=js&"
import style0 from "./McTabTable.vue?vue&type=style&index=0&id=e0863772&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports